<template>
  <tr class="m-0 border-t p-0 even:bg-$c-muted/50">
    <slot />
  </tr>
</template>
